import { ErrorInfo } from 'react';
import { faro } from './faroUtils';

export const logMessage = (
  message: string,
  options?: {[key: string]: string},
) => {
  if (window.location.hostname === 'localhost') {
    console.log(message);
    return;
  }
  faro.api.pushLog(
    [message],
    options && {
      context: {
        ...(options.severity ? { severity: options.severity } : {})
      },
    },
  );
};

